<template>
  <article class="transaction-history">
    <v-data-table
      class="position-relative mobile-scroll-table1"
      :headers="headersTransactions"
      :items="transactions"
      height="300"
      :items-per-page="-1"
      hide-default-footer
      fixed-header
      disable-sort
    >
      <template v-slot:item.price="{ item }">
        <div
          v-if="item.paymentType === 'terminal'"
          class="text-no-wrap"
        >
          {{ item.price | amountWithCurrency0 }} ({{ item.quantityChecks }})
        </div>
        <div
          v-else
          class="text-no-wrap"
        >
          {{ item.price | amountWithCurrency0 }}
        </div>
      </template>
      <template v-slot:item.cashAfter="{ item }">
        <div class="text-no-wrap">
          {{ item.fCashAfter | amountWithCurrency0 }}
        </div>
      </template>
      <template v-slot:item.terminalAfter="{ item }">
        <div
          v-if="item.transitType === 'courier_transit'"
          class="text-no-wrap"
        >
          {{ item.fTerminalAfter | amountWithCurrency0 }} ({{ item.fChecksAfter }})
        </div>
      </template>
      <template v-slot:item.operatorName="{ item }">
        <span>{{ item.operatorName || '-' }}</span>
      </template>
      <template v-slot:item.purposeDescription="{ item }">
        <span>{{ item.purposeDescription || '-' }}</span>
      </template>
      <template #no-data>
        <span></span>
      </template>
      <template #footer>
        <div v-if="!transactions.length" class="transaction-history-no-data">
          <span>Отсутствуют данные</span>
        </div>
      </template>
    </v-data-table>
  </article>
</template>

<script>
  export default {
    name: 'TransactionHistoryTable',
    props: {
      transactions: Array,
    },
    data () {
      return {
        headersTransactions: [
          { text: 'Время', value: 'time' },
          { text: 'Инициатор', value: 'senderName' },
          { text: 'Действие', value: 'operationType' },
          { text: 'Приемщик', value: 'operatorName' },
          { text: 'Тип транзакции', value: 'transitTypeDescription' },
          { text: 'Назначение', value: 'purposeDescription' },
          { text: 'Вид', value: 'paymentTypeDescription', width: '10%' },
          { text: 'Сумма', value: 'price', align: 'center', width: '10%' },
          { text: 'Остаток наличные', value: 'cashAfter', align: 'center', width: '10%' },
          { text: 'Остаток терминал', value: 'terminalAfter', align: 'center', width: '10%' },
        ],
      }
    },
  }
</script>

<style scoped lang="less">
.transaction-history {
  background-color: @color-secondary;
  padding: 15px 15px;
  border-radius: 10px;

  &-no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: rgba(0, 0, 0, 0.38);
    font-size: 20px;
  }
}
</style>
